<template>
  <generic-container
    v-bind:show_plus="true"
    icon="university"
    :title="$t('correlation')"
    :show_refresh="true"
    @refresh="init"
    v-on:add="add"
  >
    <table
      class="ui compact celled striped selectable table"
      ref="table"
      style="width: 100%"
    >
      <thead>
        <tr>
          <th>{{ $t("user name") }}</th>
          <th>{{ $t("document type") }}</th>
          <th>{{ $t("number") }}</th>
          <th>{{ $t("status") }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
    <correlation-modal
      :user_catalog="user_catalog"
      :movement_type_catalog="movement_type_catalog"
      ref="correlation_modal"
      @success="init"
    />
    <editcorrelation-modal ref="editcorrelation_modal" @success="init" />
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import {
  local_api,
  error_toast,
  register_listener,
  init_ajax_data_datables,
} from "@/utils";
import correlationModal from "@/modules/collegiate_account/configuration_modal/correlation_modal/Index";
import editcorrelationModal from "@/modules/collegiate_account/configuration_modal/correlation_modal/EditIndex";

export default {
  name: "CollegiateConfigurationModalUserMovements",
  components: {
    GenericContainer,
    correlationModal,
    editcorrelationModal,
  },
  props: {},
  data() {
    return {
      user_catalog: [],
      movement_type_catalog: [],
    };
  },
  methods: {
    init() {
      let vm = this;
      let columns = [
        {
          data: function(row) {
            return row.usr_user.name || "";
          },
        },
        {
          data: function(row) {
            return row.col_account_movement_type.name || "";
          },
        },
        {
          data: function(row) {
            return row.number || "";
          },
        },
        {
          data: function(row) {
            return row.status || "";
          },
        },
        {
          data: function(row) {
            // console.log(row);
            return `<div class="ui mini icon button" data-tooltip="${vm.$t(
              "edit"
            )}" onclick="window.dispatchEvent(new CustomEvent('edit_correlation', {'detail': { uuid: '${
              row.uuid
            }'}}))">
                        <i class="orange edit icon"></i>
                      </div>
                      <div class="ui mini red icon button" data-tooltip="${vm.$t(
                        "delete"
                      )}" onclick="window.dispatchEvent(new CustomEvent('delete_correlation', {'detail': { uuid: '${
              row.uuid
            }'}}))">
                        <i class="trash icon"></i>
                      </div>`;
          },
        },
      ];

      let onSelect = (/* data */) => {
        // console.log("select type", data);
        // vm.show_course(data);
      };
      let onCreatedRow = () => {
        // console.log("created row", data);
      };
      let onPageChanged = (data) => {
        console.log("page changed", data);
        // vm.show_course(data);
      };

      let options = {
        stateSaveParams: () => {
          //   register_listener("delete_correlation", function(e) {
          //     let uuid = e.detail.uuid;
          //     vm.$alertify.confirm(
          //       vm.$t("are you sure to remove correlative?"),
          //       function() {
          //         local_api(vm, "post", "/collegiate/collegiate/do-remove", {
          //           u: uuid,
          //         })
          //           .then(() => {
          //             vm.init();
          //           })
          //           .catch((err) => {
          //             error_toast(err);
          //           });
          //       }
          //     );
          //   });
          register_listener("edit_correlation", function(e) {
            // let vm = this;
            let uuid = e.detail.uuid;
            console.log("edit uuid", uuid);
            vm.$refs.editcorrelation_modal.show_modal({
              uuid: uuid,
            });
          });

          register_listener("delete_correlation", function(e) {
            let uuid = e.detail.uuid;
            vm.$alertify.confirm(
              vm.$t("are you sure to remove correlation?"),
              function() {
                local_api(vm, "post", "/collegiate/correlation/do-remove", {
                  u: uuid,
                })
                  .then(() => {
                    vm.init();
                  })
                  .catch((err) => {
                    error_toast(err);
                  });
              }
            );
          });

          // register_listener("edit_collegiate", function(e) {
          //   let uuid = e.detail.uuid;
          //   vm.$refs.collegiate_modal.show_modal({ uuid: uuid });
          // });

          // register_listener("view_collegiate", function(e) {
          //   let uuid = e.detail.uuid;
          //   vm.$router.push({
          //     name: "CollegiateView",
          //     query: { i: uuid },
          //   });
          // });
        },
      };

      vm.datatable = init_ajax_data_datables(
        vm,
        vm.$refs.table,
        window.jQuery.fn.api.settings.api["collegiate correlations url"],
        columns,
        onSelect,
        onCreatedRow,
        onPageChanged,
        options
      );

      // let options = {};

      // init_json_local_data_datables(
      //   vm,
      //   vm.$refs.table,
      //   list,
      //   columns,
      //   onSelect,
      //   onCreatedRow,
      //   onPageChanged,
      //   options
      // );
      // let columns = [
      //   {
      //     data: function (row) {
      //       let name = "";
      //       if (row.first_name) name = row.first_name;
      //       if (row.second_name) name += ` ${row.second_name}`;
      //       if (row.other_name) name += ` ${row.other_name}`;
      //       if (row.first_surname) name += ` ${row.first_surname}`;
      //       if (row.last_surname) name += ` ${row.last_surname}`;
      //       return name;
      //     },
      //   },
      //   {
      //     data: function (row) {
      //       return row.col_collegiate_type.name || "";
      //     },
      //   },
      //   {
      //     data: function (row) {
      //       return row.collegiate_number || "";
      //     },
      //   },
      //   // {
      //   //   data: function (row) {
      //   //     return row.health_register_number || "";
      //   //   },
      //   // },
      //   {
      //     data: function (row) {
      //       if (row.gender == "M") return vm.$t("male");
      //       else if (row.gender == "F") return vm.$t("female");
      //       else return row.gender;
      //     },
      //   },
      //   {
      //     data: function (row) {
      //       return row.email || "";
      //     },
      //   },
      //   {
      //     data: function (row) {
      //       return row.cell_phone || "";
      //     },
      //   },
      //   {
      //     data: function (row) {
      //       return row.col_university ? row.col_university.name : "";
      //     },
      //   },
      //   {
      //     width: "12%",
      //     data: function (row) {
      //       let r = "";
      //       r += `<div class="ui mini icon basic button" onclick="window.dispatchEvent(new CustomEvent('view_collegiate', { detail: { uuid: '${
      //         row.uuid
      //       }'}}))" data-tooltip="${vm.$t("view")}">
      //                 <i class="blue eye icon"></i>
      //               </div>`;
      //       r += `<div class="ui mini icon basic button" onclick="window.dispatchEvent(new CustomEvent('edit_collegiate', { detail: { uuid: '${
      //         row.uuid
      //       }'}}))" data-tooltip="${vm.$t("edit")}">
      //                 <i class="orange edit icon"></i>
      //               </div>`;
      //       r += `<div class="ui mini icon basic button" onclick="window.dispatchEvent(new CustomEvent('delete_collegiate', { detail: { uuid: '${
      //         row.uuid
      //       }'}}))" data-tooltip="${vm.$t("delete")}">
      //                 <i class="red trash icon"></i>
      //               </div>`;
      //       return r;
      //     },
      //   },
      // ];

      // let onSelect = (/* data */) => {
      //   // vm.$router.push({
      //   //   name: "CollegiateView",
      //   //   query: { i: data.uuid },
      //   // });
      // };
      // let onCreatedRow = () => {};
      // let onPageChanged = () => {
      //   vm.register_listeners();
      // };

      // let options = {
      //   stateSaveParams: () => {
      //     register_listener("delete_collegiate", function (e) {
      //       let uuid = e.detail.uuid;
      //       vm.$alertify.confirm(
      //         vm.$t("are you sure to remove collegiate?"),
      //         function () {
      //           local_api(vm, "post", "/collegiate/collegiate/do-remove", {
      //             u: uuid,
      //           })
      //             .then(() => {
      //               vm.init();
      //             })
      //             .catch((err) => {
      //               error_toast(err);
      //             });
      //         }
      //       );
      //     });

      //     register_listener("edit_collegiate", function (e) {
      //       let uuid = e.detail.uuid;
      //       vm.$refs.collegiate_modal.show_modal({ uuid: uuid });
      //     });

      //     register_listener("view_collegiate", function (e) {
      //       let uuid = e.detail.uuid;
      //       vm.$router.push({
      //         name: "CollegiateView",
      //         query: { i: uuid },
      //       });
      //     });
      //   },
      // };

      // vm.datatable = init_ajax_data_datables(
      //   vm,
      //   vm.$refs.table,
      //   window.jQuery.fn.api.settings.api["collegiate url"],
      //   columns,
      //   onSelect,
      //   onCreatedRow,
      //   onPageChanged,
      //   options
      // );

      setTimeout(() => {
        vm.register_listeners();
      }, 1000);
    },
    // refresh() {
    //   let vm = this;
    //   local_api(vm, "post", "/collegiate/correlation/do-get-list", {})
    //     .then((list) => {
    //       console.log(list);
    //       let columns = [
    //         {
    //           data: function(row) {
    //             return row.usr_user.name || "";
    //           },
    //         },
    //         {
    //           data: function(row) {
    //             return row.col_account_movement_type.name || "";
    //           },
    //         },
    //         {
    //           data: function(row) {
    //             return row.number || "";
    //           },
    //         },
    //         {
    //           data: function(row) {
    //             return row.status || "";
    //           },
    //         },
    //         {
    //           data: function(row) {
    //             // console.log(row);
    //             return `<div class="ui mini icon button" data-tooltip="${vm.$t(
    //               "edit"
    //             )}" onclick="window.dispatchEvent(new CustomEvent('edit_correlation', {'detail': { uuid: '${
    //               row.uuid
    //             }'}}))">
    //                     <i class="orange edit icon"></i>
    //                   </div>
    //                   <div class="ui mini red icon button" data-tooltip="${vm.$t(
    //                     "delete"
    //                   )}" onclick="window.dispatchEvent(new CustomEvent('delete_correlation', {'detail': { uuid: '${
    //               row.uuid
    //             }'}}))">
    //                     <i class="trash icon"></i>
    //                   </div>`;
    //           },
    //         },
    //       ];

    //       let onSelect = (/* data */) => {
    //         // console.log("select type", data);
    //         // vm.show_course(data);
    //       };
    //       let onCreatedRow = () => {
    //         // console.log("created row", data);
    //       };
    //       let onPageChanged = (data) => {
    //         console.log("page changed", data);
    //         // vm.show_course(data);
    //       };
    //       let options = {};

    //       init_json_local_data_datables(
    //         vm,
    //         vm.$refs.table,
    //         list,
    //         columns,
    //         onSelect,
    //         onCreatedRow,
    //         onPageChanged,
    //         options
    //       );

    //       setTimeout(() => {
    //         vm.register_listeners();
    //       }, 500);
    //     })
    //     .catch((err) => {
    //       error_toast(err);
    //     });
    // },
    add() {
      let vm = this;
      vm.$refs.correlation_modal.show_modal();
      // vm.$alertify.prompt(
      //   this.$t("enter university name"),
      //   "",
      //   function (element, value) {
      //     local_api(vm, "post", "/collegiate/university/do-save", {
      //       n: value,
      //     })
      //       .then(() => {
      //         vm.refresh();
      //       })
      //       .catch((err) => {
      //         error_toast(err);
      //       });
      //   },
      // );
    },
    register_listeners() {
      let vm = this;
      register_listener("edit_correlation", function(e) {
        let uuid = e.detail.uuid;
        console.log("edit uuid", uuid);
        vm.$refs.editcorrelation_modal.show_modal({
          uuid: uuid,
        });
      });

      register_listener("delete_correlation", function(e) {
        let uuid = e.detail.uuid;
        vm.$alertify.confirm(
          vm.$t("are you sure to remove correlation?"),
          function() {
            local_api(vm, "post", "/collegiate/correlation/do-remove", {
              u: uuid,
            })
              .then(() => {
                vm.init();
              })
              .catch((err) => {
                error_toast(err);
              });
          }
        );
      });
    },
    update_user_list(list) {
      this.user_catalog = list;
      // console.log("update country catalog", list);
    },
    update_document_type_list(list) {
      this.movement_type_catalog = list;
      // console.log("update country catalog", list);
    },
  },
  mounted() {
    let vm = this;
    local_api(vm, "post", "/collegiate_account_movement_type/do-get-list", {})
      .then((movementTypes) => {
        vm.movement_type_catalog = movementTypes;
        vm.update_document_type_list(movementTypes);
      })
      .catch((err) => {
        console.log(err);
      });

    local_api(vm, "post", "/user/do-get-list", {})
      .then((usrs) => {
        vm.user_catalog = usrs;
        vm.update_user_list(usrs);
      })
      .catch((err) => {
        console.log(err);
      });
    vm.init();
  },
};
</script>
